<script setup>
const props = defineProps({
    button: {
        type: [Object, Boolean],
        required: false,
        default: false,
    },
    label: {
        type: String,
        required: false,
        default: '',
    },
    link: {
        type: [String, Boolean],
        required: false,
        default: false,
    },
    icon: {
        type: [String, Boolean],
        required: false,
        default: '',
    },
    title: {
        type: String,
        required: false,
        default: '',
    },
    targetOverride: {
        type: Boolean,
        default: false,
    },
});

const text = computed(() => {
    if (props.label) return props.label;
    if (props.button) return props.button.label;
    return '';
});

const buttonTitle = computed(() => {
    if (props.button) return props.button.title;
    if (props.title) return props.title;
    return false;
});

const href = computed(() => {
    if (props.link) return props.link;
    if (props.button) return props.button.url;
    return false;
});

const target = computed(() => {
    if (props.button) return props.button.target;
    if (props.targetOverride) return props.targetOverride;
    return false;
});
</script>

<template>
    <MessLink v-if="href" class="mess-button base" :href="href" :target="target ? '_blank' : '_self'"
        :title="buttonTitle || null">
        <span class="wrapper">
            <MessHtml :html="text" tag="span" />
            <span class="icon-wrapper">
                <MessSvg :type="icon" />
            </span>
        </span>
        <slot />
        <span v-if="target" class="sr-only">(opens in a new tab)</span>
    </MessLink>
    <button v-else class="mess-button base" :title="title || null">
        <span class="wrapper">
            <MessHtml :html="text" tag="span" />
            <span class="icon-wrapper">
                <MessSvg :type="icon" />
            </span>
        </span>
        <slot />
    </button>
</template>
